const data = {
  name: '全部',
  getList: '',
  getDetail: '',
  status: null,
  columns: [
    // {
    //   prop: 'id',
    //   label: '序号',
    //   width: '100'
    // },
    {
      prop: 'fileName',
      label: '文件名称',
      width: '150'
    }, {
      prop: 'areaName',
      label: '所属区域',
      width: '120'
    }, {
      prop: 'userId',
      label: '上传者',
      width: '120'
    }, {
      prop: 'createTime',
      label: '上传时间',
      width: '120'
    }, {
      fixed: 'right',
      label: '操作',
      width: '100'
    }
  ]
}

export default data
